import queryString from 'query-string';
import getLodash from 'lodash.get';
import camelCase from 'camelcase';

function whatDecimalSeparator() {
  let n = 1.1;
  n = n.toLocaleString().substring(1, 2);
  return n;
}

const localeDecimalSep = whatDecimalSeparator();

export const perCentToString = (perCentValue) => {
  const int100 = Math.round(Number(perCentValue) * 100 * 100);
  const inter = Math.trunc(int100 / 100);
  const decimal = Math.abs(int100 - inter * 100)
    .toString()
    .padStart(2, '0');
  return `${inter.toString()}${localeDecimalSep}${decimal}%`;
};

export const perCentToStringPure = (perCentValue) => {
  const int100 = Math.round(Number(perCentValue) * 100 * 100);
  const inter = Math.trunc(int100 / 100);
  const decimal = Math.abs(int100 - inter * 100)
    .toString()
    .padStart(2, '0');
  return `${inter.toString()}${localeDecimalSep}${decimal}`;
};

export function percentageToString(value, withoutSign) {
  const minus = value < 0 ? '-' : '';
  const number = Math.abs(Number.parseFloat(value) * 100);

  return `${!withoutSign && minus}${number.toFixed(2).toLocaleString()}%`;
}

export function get(item, accessor) {
  return getLodash(item, accessor);
  // const accPath = accessor.split('.');
  // return accPath.reduce((cursor, key) => cursor?.[key], item);
}

export function replaceValues(string, values) {
  return values.reduce((newString, value, i) => {
    return newString.replace(`{${i}}`, value.toString());
  }, string);
}

export function formatDate(date, lang) {
  return new Date(date).toLocaleDateString(lang);
}

export function formatTime(time, lang) {
  return new Date(time).toLocaleTimeString(lang, { hour: '2-digit', minute: '2-digit' });
}

export function formatDateTime(dateTime, lang) {
  return new Date(dateTime).toLocaleDateString(lang, { dateStyle: 'short', timeStyle: 'short' });
}

export function toStringFixed(value, lang, digits = 2) {
  return Number.parseFloat(value).toLocaleString(lang, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
}

export function toPercentageString(value, lang, digits) {
  return `${toStringFixed(value * 100, lang, digits)}%`;
}

export function getInitialFilters(search) {
  const parsed = queryString.parse(search);
  return Object.entries(parsed).map((arr) => {
    const id = arr[0];
    let value = arr[1];
    if (value.charAt(0) === '[') {
      try {
        value = JSON.parse(value);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(error);
      }
    }
    return { id, value };
  });
}

export function pascalCase(string) {
  return camelCase(string, { pascalCase: true });
}

export function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
